export enum LoadingStateActionTypes {
  MODEL_LOADING_STARTED = 'MODEL_LOADING_STARTED',
  MODEL_LOADING_COMPLETED = 'MODEL_LOADING_COMPLETED',
  MODEL_LOADING_FAILED = 'MODEL_LOADING_FAILED',
  MODEL_LOADING_INVALIDATED = 'MODEL_LOADING_INVALIDATED',
}

export interface LoadingStartedAction {
  type: LoadingStateActionTypes.MODEL_LOADING_STARTED;
  modelType: string;
  modelKeys: Array<string>;
}
export function loadingStarted(modelType: string, modelKeys: Array<string>): LoadingStartedAction {
  return {
    type: LoadingStateActionTypes.MODEL_LOADING_STARTED,
    modelType,
    modelKeys,
  };
}

export interface LoadingCompletedAction {
  type: LoadingStateActionTypes.MODEL_LOADING_COMPLETED;
  modelType: string;
  modelKeys: Array<string>;
}
export function loadingCompleted(modelType: string, modelKeys: Array<string>): LoadingCompletedAction {
  return {
    type: LoadingStateActionTypes.MODEL_LOADING_COMPLETED,
    modelType,
    modelKeys,
  };
}

export interface LoadingFailedAction {
  type: LoadingStateActionTypes.MODEL_LOADING_FAILED;
  modelType: string;
  modelKeys: Array<string>;
}
export function loadingFailed(modelType: string, modelKeys: Array<string>): LoadingFailedAction {
  return {
    type: LoadingStateActionTypes.MODEL_LOADING_FAILED,
    modelType,
    modelKeys,
  };
}

/*
 * This action removes the tracking of a model from loading state to handle the
 * case where an already loaded model is removed from its underlying store.
 *
 * Note that removing a model from a store is an atypical pattern and may result
 * in crashes / permanent loading state for components that "fetch on mount"
 * instead of "fetch when data is missing". For components that do use a
 * ModelManager, calling this action should help avoid permanent loading state.
 */
export interface LoadingInvalidatedAction {
  type: LoadingStateActionTypes.MODEL_LOADING_INVALIDATED;
  modelType: string;
  modelKeys: Array<string>;
}
export function loadingInvalidated(modelType: string, modelKeys: Array<string>): LoadingInvalidatedAction {
  return {
    type: LoadingStateActionTypes.MODEL_LOADING_INVALIDATED,
    modelType,
    modelKeys,
  };
}

export type LoadingStateAction =
  | LoadingStartedAction
  | LoadingCompletedAction
  | LoadingFailedAction
  | LoadingInvalidatedAction;
